
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/nissen",
      function () {
        return require("private-next-pages/cases/nissen/index.tsx");
      }
    ]);
  